import { createSlice } from '@reduxjs/toolkit'
import {getVenues} from "@/store/venue-summary/action";

const initialState = {
  state: {
    venues: [],
    paging: {
      page: 0,
      size: 0,
      total_page: 0,
      total_size: 0
    }
  },
  loading: true,
  error: ''
} as BaseState<VenueSummaryState>

const slice = createSlice({
  name: 'venueSummarySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVenues.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(getVenues.fulfilled, (state, action) => {
      const { items, paging } = action.payload
      return {
        state: {
          paging,
          venues: items
        },
        loading: false,
        error: null
      }
    })
    builder.addCase(getVenues.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get Venues'
    }))
  }
})

export default slice